import { Col, Modal, Row } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { allapiAction } from "../../Redux/common/action";
import { toast } from "react-toastify";

function PackageLsit() {
  const dispatch = useDispatch();
  const router = useNavigate();

  const locationv = useLocation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [packageDetails, setpackageDetails] = useState({});

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = (e) => {
    setIsModalOpen(true);
    setpackageDetails(e);
    return () => {};
  };

  const searchParams = new URLSearchParams(locationv.search);
  const search = searchParams.get("search");
  const location = searchParams.get("location");
  const page = searchParams.get("page");

  const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  const pageno = page ? page : 1;
  const listdata = get_product_list?.docs ? get_product_list?.docs : [];

  const [first, setfirst] = useState(0);

  const orderSumit = async (e) => {
    // createOrder

    // if (PaymentMethod == "online") {
    //   displayRazorpay();
    // } else {

    // const orderAddress = localStorage.getItem("order_Address");

    // console.log(orderAddress);
    // const obj = JSON.parse(orderAddress);
    // console.log(obj);

    // if (first == 0) {
    //   toast?.error("Please enter amount");
    //   return;
    // }

    // if (first < packageDetails?.price) {
    //   toast?.error("Please enter amount more than " + packageDetails?.price);
    //   return;
    // }
    // if (first > packageDetails?.price2) {
    //   toast?.error("Please enter amount less than " + packageDetails?.price2);
    //   return;
    // }

    const response = await dispatch(
      allapiAction.createOrder(
        {
          packageId: packageDetails?._id,
          amount: packageDetails?.price,
          // user_email: get_user_profile?.email,
          // user_mobile: get_user_profile?.phone,
          // delivery_charges: "0",
          // sub_total: totalSubtotalPrice,
          // address_id: obj,
          payment_mode_name: "wallet",
          // products_ids: commentsData,
        },
        router
      )
    );
    if (response.success) {
      setIsModalOpen(false);
      setfirst(0);
    } else {
    }

    return () => {};
    // }
  };

  return (
    <div>
      <Modal
        title="purchase"
        open={isModalOpen}
        onOk={orderSumit}
        onCancel={handleCancel}
        width={400}
      >
        <Row>
          <Col span={24}>Are You Sure You Want To Buy this property</Col>
          <Col span={24}>
            {/* <input
              type="number"
              className="form-control"
              value={first}
              onChange={(e) => setfirst(e.target.value)}
            /> */}
          </Col>
        </Row>
      </Modal>

      {listdata &&
        listdata?.map((data, i) => {
          return (
            <div class="col-12 stake-card border my-3">
              <div class="card-header">
                <h5>
                  Plot No. : <small>{data?.title} </small>
                  {/* <a href="">
                                <img
                                  class="tlogo-img-position"
                                  src="img/icons8-help-18.png"
                                  alt=""
                                />
                              </a> */}
                </h5>
                {/* <h5 class="badge-level">
                  <small>LV2 - LV6</small>
                </h5> */}
              </div>
              <img
                src="https://media.istockphoto.com/id/1409298953/photo/real-estate-agents-shake-hands-after-the-signing-of-the-contract-agreement-is-complete.jpg?s=612x612&w=0&k=20&c=SFybbpGMB0wIoI0tJotFqptzAYK_mICVITNdQIXqnyc="
                class="banner my-2"
                alt="NFT Exclusive Zone"
              />

              <div>
                <div class="d-flex justify-content-between">
                  <p>
                    <small class="text-muted">Status</small>
                  </p>
                  <p>
                    {" "}
                    <small class="status-open">{data?.status}</small>
                  </p>
                </div>

                <div class="d-flex justify-content-between">
                  <p>
                    <small class="text-muted">Price :</small>
                  </p>
                  <p class="">
                    <small>
                      <img
                        class="tlogo-img-position"
                        src="img/t logo.png"
                        alt=""
                      />
                      {/* 199 - 1,000 */}
                      {data?.price}
                    </small>
                  </p>
                </div>
                <div class="d-flex justify-content-between">
                  <p class="text-muted">
                    <small>Area:</small>
                  </p>
                  <p class="">
                    <small>Gaj :{data?.gaj}</small>
                  </p>
                </div>
                {/* <div class="d-flex justify-content-between">
                              <p class="text-muted">
                                <small>Handling Fee: </small>
                              </p>
                              <p>1%</p>
                            </div> */}
              </div>
              <button class="btn-stake" onClick={() => handleOk(data)}>
                BUY PLOT
              </button>
            </div>
          );
        })}
    </div>
  );
}

export default PackageLsit;
